import Vue from 'vue'
import Router from 'vue-router'
import Course from '../components/views/Course'
import CourseList from '../components/views/CourseList'
import BrandStory from '../components/views/BrandStory'
import Download from '../components/views/Download'
import Contact from '../components/views/Contact'
import Help from '../components/views/Help'
import Terms from '../components/views/Terms'
import Info from '../components/views/Info'


import AuthorList from '../components/views/AuthorList'
import Home from '../components/views/Home'
import MainLayout from '../components/dashboard/MainLayout.vue'
import My from '../components/views/My'
import MyProfile from '../components/views/mySubviews/MyProfile'
import MyCoupon from '../components/views/mySubviews/MyCoupon'


import MyCourse from '../components/views/mySubviews/MyCourse'
import Msg from '../components/views/Msg'

import coupon_Android from '../components/views/coupon_Android'
import coupon_iOS from '../components/views/coupon_iOS'


import point_payment  from '../components/views/point_payment'

import MyTransaction from '../components/views/mySubviews/MyTransaction'
import MyDevice from '../components/views/mySubviews/MyDevice'
// import VueYoutube from 'vue-youtube'
import VueAnalytics from 'vue-ua'

import store from '@/assets/js/store' // your vuex store
Vue.use(Router)



// Check this user has authentication
const ifAuthenticated = (to, from, next) => {
  store.commit('savePath', to.path)


  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/msg')
}

export default new Router({

  mode: 'history',
  hash: false,
  routes: [

    {
      path: '/',
      component: MainLayout,
      children: [{
        path: '/',
        name: 'main',
        component: Home,
        meta: {
          breadcrumb: [{
              name: '首頁',
              path: '/'
            },
            {
              name: '首頁',
              path: '/'
            },

          ]
        }
      }]
    },
    {
      path: '/',
      component: MainLayout,
      children: [{
          path: 'index',
          name: 'main',
          component: Home,
          meta: {
            breadcrumb: [{
                name: '首頁',
                path: '/'
              },
              {
                name: '首頁',
                path: '/'
              },
            ]
          }
        },
        {
          path: 'channel/list',
          name: 'channel',
          component: CourseList,
          meta: {
            breadcrumb: [{
                name: '首頁',
                path: '/main-content/channels-manager'
              },
              {
                name: '鯨選課程',
                path: '/channel_list'
              },

            ]
          }
        },
        {
          path: 'author/list',
          name: 'authorList',
          component: AuthorList,
          meta: {
            breadcrumb: [{
                name: '首頁',
                path: '/'
              },
              {
                name: '鯨選大師',
                path: '/author_list'
              },
            ]
          }
        }, {
          path: 'channel/:id',
          name: 'course',
          component: Course,
          meta: {
            breadcrumb: [{
                name: '首頁',
                path: '/'
              },
              {
                name: '鯨選課程',
                path: '/channel_list'
              },
            ]
          }
        }, {
          path: 'member',
          component: My,
          beforeEnter: ifAuthenticated,
          children: [{
            path: 'profile',
            name: 'profile',
            component: MyProfile,
            beforeEnter: ifAuthenticated,
          meta: {

            breadcrumb: [{
                    name: '首頁',
                      path: '/'
                    }, {
                      name: '我的',
                      path: '/member'
                    }, {
                      name: '我的帳戶',
                      path: '/member/profile'
                    },
            ]
          }
          }]
        }, 
        {
          path: 'member',
          component: My,
          children: [
            {
              path: 'profile',
              name: 'profile',
              component: MyProfile,
              beforeEnter: ifAuthenticated,
             meta: {
               breadcrumb: [{
                   name: '首頁',
                   path: '/'
                 },
                 {
                   name: '我的',
                   path: '/member'
                 },
                 {
                   name: '我的帳戶',
                   path: '/member/profile'
                 },
               ]
             }
            
            
            },

           
            {
              path: 'coupon',
              name: 'coupon',
              component: MyCoupon,
              beforeEnter: ifAuthenticated,
           meta: {
               breadcrumb: [{
                   name: '首頁',
                   path: '/'
                 },
                 {
                   name: '我的',
                   path: '/member'
                 },
                 {
                   name: '優惠券',
                   path: '/member/coupon'
                 },
               ]
             }
            },
            {
              path: 'order',
              name: 'order',
              component: MyCourse,
              beforeEnter: ifAuthenticated,
           meta: {
               breadcrumb: [{
                   name: '首頁',
                   path: '/'
                 },
                 {
                   name: '我的',
                   path: '/member'
                 },
                 {
                   name: '已購買課程',
                   path: '/member/order'
                 },
               ]
             }
            },
            {
              path: 'record',
              name: 'record',
              component: MyTransaction,
              beforeEnter: ifAuthenticated,
              meta: {

                breadcrumb: [{
                    name: '首頁',
                    path: '/'
                  },
                  {
                    name: '我的',
                    path: '/member'
                  },
                  {
                    name: '交易紀錄',
                    path: '/member/record'
                  },
                ]
              }
            },
            {
              path: 'device',
              name: 'device',
              component: MyDevice,
              beforeEnter: ifAuthenticated,
             meta: {

               breadcrumb: [{
                   name: '首頁',
                   path: '/'
                 },
                 {
                   name: '我的',
                   path: '/member'
                 },
                   {
                     name: '裝置管理',
                     path: '/member/device'
               },
               ]
             }
            },
          ]
        },
        {
          path: 'story',
          name: 'story',
          component: BrandStory,
          meta: {

            breadcrumb: [{
                name: '首頁',
                path: '/main-content/channels-manager'
              },
              {
                name: '品牌故事',
                path: '/story'
              },

            ]
          }
        },

        {
          path: 'app',
          name: 'app',
          component: Download,
          meta: {

            breadcrumb: [{
                name: '首頁',
                path: '/main-content/channels-manager'
              },
              {
                name: '下載App',
                path: '/app'
              },

            ]
          }
        },
        {
          path: 'contact',
          name: 'contact',
          component: Contact,
          meta: {
            breadcrumb: [{
              name: '首頁',
              path: '/main-content/channels-manager'
            },
            {
              name: '聯絡我們',
              path: '/contact'
            },

          ]
           
          }
        },
        {
          path: 'help',
          name: 'help',
          component: Help,
          meta: {
            breadcrumb: [{
              name: '首頁',
              path: '/main-content/channels-manager'
            },
            {
              name: '常見問題',
              path: '/help'
            },

          ]
           
          }
        },
        {
          path: 'terms',
          name: 'terms',
          component: Terms,
          meta: {
            breadcrumb: [{
              name: '首頁',
              path: '/main-content/channels-manager'
            },
            {
              name: '服務條款',
              path: '/terms'
            },

          ]
           
          }
        },
        {
          path: 'info',
          name: 'info',
          component: Info,
          meta: {
            breadcrumb: [{
              name: '首頁',
              path: '/main-content/channels-manager'
            },
            {
              name: '補充說明',
              path: '/info'
            },

          ]
           
          }
        },

        {
          path: 'msg',
          name: 'msg',
          component: Msg,
          meta: {
            breadcrumb: [{
              name: '首頁',
              path: '/main-content/channels-manager'
            },
            {
              name: '訊息頁',
              path: '/msg'
            },

          ]
           
          }
        },
        {
          path: 'coupon_Android',
          name: 'coupon_Android',
          component: coupon_Android,
        },
        {
          path: 'coupon_iOS',
          name: 'coupon_iOS',
          component: coupon_iOS,
        },

        {
          path: 'help/point_payment.html',
          name: 'point_payment.html',
          component: point_payment,
        
        },

        
        
       
      ]
    },


    {
      path: "*",
      redirect: "/"
    }
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js